<template>
  <div class="error-page">
    <h1>403 - Access Denied</h1>
    <p>You do not have permission to access this page.</p>
  </div>
</template>

<script>
export default {
  name: "ForbiddenPage"
};
</script>

<style scoped>
.error-page {
  text-align: center;
  margin-top: 100px;
}

.error-page h1 {
  font-size: 48px;
  color: #ff4500;
}

.error-page p {
  font-size: 18px;
  color: #333;
}
</style>
